class RedPepper {}

export default RedPepper;
